export class BaseDataLayerItem {
  event;

  constructor(model = {}) {
    this.event = model.event;
  }
}
